import React from 'react';
import './GameSingle.css';

import { Lightbox, PageTitle, SidebarHeading, Faqs } from '../../../components';
import { games } from '../../../constants';
import { renderIcon } from '../../../utils';

import { FaCheck } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { FaFilePdf, FaCalendarDays } from 'react-icons/fa6';

const GameSingle = () => { 

  const location = useLocation();  
  const GameSingle = location.state; 

  const features = GameSingle.features;
  const process = GameSingle.process;
  const category = GameSingle.category;
  const requirements = GameSingle.requirements;
  const arenas = GameSingle.arenas;
  const downloads = GameSingle.downloads;

  return (
    <>
      {/* Page Title */}
      <PageTitle title={GameSingle.title} page={GameSingle.title} />

      <section className='game-single page-single'>

        <div className='sidebar game-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'競賽種類'} />

            <div className='box-container'>
              {games.map(game => {
                return  (                
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Games/' + game.title,
                  }}
                  location = {{game}}
                  state= {game}
                  key={game.id}
                  className='item'><span><div className='icon'>{renderIcon(game.title)}</div>{game.title}</span> {/* Service Title */}
                </Link> )
              })}
            </div>

            </div>

        </div>

        <div className='game-info page-info'>

          {/* Service Image */}
          <div className='image'>
            <img src={GameSingle.image} alt={GameSingle.title} />
          </div>

          <div className='content'>

            {/* Service heading */}
            <h3 className='main-heading'>{GameSingle.title}</h3>

            {/* Service Content */}
            {GameSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

          </div>

          {/* Service Image gallery */}
          <Lightbox images={GameSingle.gallery} />

          {/* Section for service benefits */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>分類與分組</h3>

            <p>{category?.intro}</p>

            {/* List of service benefits */}
            <ul className="category-list">
              {/* {category.list.map((item, index) => {
                return (<li key={index}><FaCheck className='icon' />{item.title}
                  <ul>
                  {item.divisions.map((division, subIndex) => {
                     return (<li key={subIndex}><FaCheck className='icon' />{division.title}
                        <ul>
                        {division.features.map((text, featureIndex) => {
                            return (<li ><FaCheck className='icon' />{text}</li>)
                        })}
                      </ul>
                      </li>)
                  })}
                  </ul>
                </li>)
              })} */}
              {category?.list?.map((item, index) => (
                <li key={index} >
                   - {item.title}
                  <ul className="division-list">
                    {item?.divisions?.map((division, divIndex) => (
                      <li key={divIndex}>
                        {/* <FaCheck className="icon" /> */}
                        # {division.title}
                        <ul className="feature-list">
                          {division?.features?.map((text, featureIndex) => (
                            <li key={featureIndex}>
                              <FaCheck className="icon" />
                              {text}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}

            </ul>

          </div>

          {/* Section for service process */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>比賽需求與限制</h3>

            <p>{requirements?.intro}</p>

            {/* List of service process steps */}
            <ul>
              {requirements?.list?.map((requirement, index) => {
                return <li key={index}><FaCalendarDays className='icon' />{requirement}</li>
              })}
            </ul>

          </div>
          {/* Section for service process */}
          <div className='service-benefits sub-section'>

            <h3 className='sub-heading'>相關下載</h3>

            <p>{downloads?.intro}</p>
            
            {/* List of service process steps */}
            <ul>
              {downloads?.list?.map((item, downloadIndex) => {
                return <li key={item.id}><FaFilePdf className='icon' /><a href={item.url}>{item.title}</a></li>
              })}
            </ul>

          </div>

          {/* Section for frequently asked questions */}
          {/* <div className='service-faqs sub-section'>

            <h3 className='sub-heading'>frequently asked questions</h3>

            
            <Faqs faqs={GameSingle.faqs} />

          </div> */}
        
        </div> 

      </section> 
    </> 
  );
}

export default GameSingle;